import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from 'material-ui/AppBar';
import Tabs, {Tab} from 'material-ui/Tabs';
import Paper from 'material-ui/Paper';
import ContainerHeader from 'components/ContainerHeader/index';
import Button from 'material-ui/Button';

import Producers from './tabs/producers'
import Comments from './tabs/comments'

function TabContainer({children, dir}) {
    return (
        <div dir={dir} style={{padding: 8 * 3}}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
});

class Cartable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
        };
    }

    handleChange = (event, value) => {
        this.setState({value});
    };

    handleChangeIndex = index => {
        this.setState({value: index});
    };

    render() {
        const {theme} = this.props;

        return (
            <div>
                <ContainerHeader match={this.props.match} title="کارتابل"/>
                <Paper>
                    <div className="w-100">
                        <AppBar position="static" className="bg-primary">
                            <Tabs
                                value={this.state.value}
                                onChange={this.handleChange}
                                //indicatorColor="primary"
                                //textColor="primary"
                                fullWidth
                                scrollable
                                scrollButtons="on"
                            >
                                <Tab className="tab" label="تولید کنندگان"/>
                                <Tab className="tab" label="نظرات کاربران"/>
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={this.state.value}
                            onChangeIndex={this.handleChangeIndex}
                        >
                            <TabContainer dir={theme.direction}>
                                <Producers/>
                            </TabContainer>
                            <TabContainer dir={theme.direction}>
                                <Comments/>
                            </TabContainer>
                        </SwipeableViews>
                    </div>
                </Paper>
            </div>
        );
    }
}

Cartable.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(Cartable);


// WEBPACK FOOTER //
// ./app/routes/toliton/cartable/cartable.js